import React, {Suspense} from "react";
import {useSelector} from 'react-redux';
import {useState} from 'react';

//components
import CollapseTab from '../../components/Tabs/CollapseTab';
import StatusIcon from '../../components/Icons/StatusIcon';
import Loading from "../../components/Loading/Loading";

//assets
import icon1 from '../../assets/icons/sections/flota.svg';


export default () => {
    const VehiclesFleetContainer = React.lazy(() => import('./components/VehiclesFleetContainer'));
    const [show, setShow] = useState(false);
    let boxData = useSelector(state => state.app.data);
    boxData = boxData && boxData.flotavehiculos;

    const totalCards = (
        (boxData && boxData.body && boxData.body.data) ?
            (
                (boxData.body.data.privateTransport ? boxData.body.data.privateTransport.data.length : 0) +
                (boxData.body.data.publicTransport ? boxData.body.data.publicTransport.data.length : 0) +
                (boxData.body.data.schoolTransport ? boxData.body.data.schoolTransport.data.length : 0)
            ) : 0
    );

    return (
        <div onClick={() => setShow(!show)} className="VehiclesFleetSection" id="flotavehiculos">
            {
              boxData && boxData.body && boxData.header && boxData.footer &&
                <CollapseTab
                    sectionName="flotavehiculos"
                    carouselLength={totalCards}
                    icon={icon1}
                    stateIcon={<StatusIcon
                        status={boxData.body && boxData.body.result && boxData.body.result.type}/>}
                    nav={<div
                        className="font-roboto font-bold font-14 txt-blue line-1-2">{boxData.header.title}</div>}>
                    <div onClick={(e) => e.stopPropagation()}>
                        <Suspense fallback={<Loading size='medium'/>}>
                            {show && <VehiclesFleetContainer boxData={boxData}/>}
                        </Suspense>
                    </div>
                </CollapseTab>
            }
        </div>
    )
}
